import { useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import ProductGalleryBlockModalButton from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModalButton/ProductGalleryBlockModalButton';
import ProductGalleryBlockModal from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModal/ProductGalleryBlockModal';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/SingleImage/SingleImage.styles';
import useBodyOverflow from '@hooks/useBodyOverflow';
import { IParsedImage } from '@components/typescript';
import { ICategoryGalleryBlockImage, TProductGallerySlide } from '@features/cms/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
const DynamicModalRootPortal = dynamic(() => import('@components/ModalRootPortal/ModalRootPortal'), {
  ssr: false
});
type PropsType = {
  image: ICategoryGalleryBlockImage;
};
const SingleImage = ({
  image
}: PropsType) => {
  const [isHoverImage, setIsHoverImage] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const modalData: TProductGallerySlide<IParsedImage> = {
    products: image.products,
    image: {
      image: {
        desktop: image.image,
        tablet: image.image,
        mobile: image.image
      },
      blur: image.imageWithBlur?.blur?.desktop ? {
        desktop: image.imageWithBlur?.blur?.desktop,
        tablet: image.imageWithBlur?.blur?.desktop,
        mobile: image.imageWithBlur?.blur?.desktop
      } : undefined
    },
    itemId: 'singleImage'
  };
  useBodyOverflow(isModalOpen, 'singleImage', false, true);
  const renderImage = useMemo(() => <ResponsiveImage sx={styles.imageStyle} image={typeof image.image === 'string' ? image.image : image.image.path} alt={typeof image.image !== 'string' ? image.image.metadata.alt || 'image' : 'image'} />, [image]);
  return image.products.length > 0 ? <>
      <button type="button" sx={styles.imageWrapper} onMouseEnter={() => {
      setIsHoverImage(true);
    }} onMouseLeave={() => {
      setIsHoverImage(false);
    }} onClick={() => setModalOpen(true)} className="photo_with_products" data-testid="categoryGalleryImage-button">
        <div sx={styles.singleImageBox}>
          {renderImage}
          <ProductGalleryBlockModalButton isExpanded={isHoverImage} />
        </div>
      </button>
      {isModalOpen && <DynamicModalRootPortal>
          <ProductGalleryBlockModal isActive={isModalOpen} slide={modalData} onClose={() => setModalOpen(false)} />
        </DynamicModalRootPortal>}
    </> : <div sx={styles.imageWrapper}>
      <div sx={styles.singleImageBox}>{renderImage}</div>
    </div>;
};
export default SingleImage;